export const GET_DECISION_STATUS_COUNT = "GET_DECISION_STATUS_COUNT";
export const GET_DECISION_COUNT_BY_MONTH = "GET_DECISION_COUNT_BY_MONTH";
